import script from "./SiteHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteHeader.vue?vue&type=script&lang=ts&setup=true"

import "./SiteHeader.vue?vue&type=style&index=0&id=0dd2631a&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd2631a"]])

export default __exports__